import {
  AuraAuthGuard,
  VerifyEmailGuard,
} from '@digital-platform/aura-authentication/guards';
import { PermissionGuard } from '@digital-platform/rs-shared/guards';

export const reportingRoutes = [
  {
    path: 'reporting',
    canMatch: [AuraAuthGuard, VerifyEmailGuard, PermissionGuard],
    data: {
      requiredPermissions: ['view:reporting'],
    },
    loadChildren: () =>
      import('reporting/Module').then((m) => m.RemoteEntryModule),
  },
];
